import React from 'react'
import { PartialPaymentModal } from '../../../payments/partial-payment-modal/PartialPaymentModal'
import { SalePayment, PartialPaymentOption } from './types'

type Props = {
  paymentOptions: PartialPaymentOption
  onSuccess: (result: SalePayment) => void
  onClose: () => void
}

export const PartialPayment = ({
  paymentOptions,
  onSuccess,
  onClose,
}: Props) => {
  const { paymentType, availableCredit, paymentTypeName } = paymentOptions
  const handleOnModalClose = (result: Promise<boolean>) => {
    result.then(makePartialPayment => {
      if (makePartialPayment) {
        onSuccess({
          paymentType,
          paymentAmount: availableCredit,
        })
      }
      onClose()
    })
  }

  return (
    <PartialPaymentModal
      availableCredit={availableCredit}
      close={handleOnModalClose}
      paymentTypeName={paymentTypeName}
    />
  )
}
